import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { BaseServices } from './../../kuba.services';
import { deviationCaseType } from './../models/deviationCaseType';
import { Department } from './../models/deviationDepartment';
import { DeviationShared } from './../models/deviationShared';
import { CreateDeviationRequestDto } from './../models/createDeviationRequest';
import { UpdateDeviationRequestDto } from './../models/updateDeviationRequest';
import { HttpClient, HttpHeaderResponse } from '@angular/common/http';
import { AuthenticationService } from 'src/app/_services';
import { FeatureKey } from 'src/app/_models';
import { LanguageId } from 'src/app/_models/language-id.enum';

@Injectable()
export class DeviationServices {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}
  getAll(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/deviation/list/' + id).pipe(rxjsmap(result => result));
  }

  getAllUsers() {
    return this.http
      .get(environment.BASE_URL + '/allusers').pipe(rxjsmap((result: any) => result));
  }

  // list deviation based on parent
  getAllByEach(id: number, key: string) {
    return this.http
      .get(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/deviation/list/${id}`
      ).pipe(rxjsmap((result: any) => result));
  }

  // Create Deviation (new endpoint)
  createDeviation(request: CreateDeviationRequestDto) {
    return this.http
      .post(`${environment.BASE_URL_V2}/kuba/v2/deviationwrite`, request).pipe(rxjsmap(result => result));
  }

  /**
   * Temperature control objects (FoodControl / KCTemperatureControl) of a food safety or Kuba Control,
   * for choosing which object a new deviation concerns. The module is passed explicitly rather than
   * read from sessionStorage, since the deviation's feature is already known.
   */
  getTemperatureControlObjects(
    featureId: number,
    parentId: number
  ): Observable<{ Id: number; ObjectName: string | null }[]> {
    const module =
      featureId === FeatureKey.KUBA_CONTROL ? 'kubacontrol' : 'foodsafety';
    return this.http.get<{ Id: number; ObjectName: string | null }[]>(
      `${environment.BASE_URL}/${module}/foodcontrols/${parentId}`
    );
  }

  // Update Deviation (new endpoint)
  updateDeviationV2(id: number, request: UpdateDeviationRequestDto) {
    return this.http
      .put(`${environment.BASE_URL_V2}/kuba/v2/deviationwrite/${id}`, request).pipe(rxjsmap(result => result));
  }

  // Update Deviation
  updateDeviation(deviation: DeviationShared, key: string) {
    let appSettings = JSON.parse(sessionStorage.getItem('appSettings'));
    let languageId = parseInt(sessionStorage.getItem('languageId'));
    let CultureInfo = '';
    switch (languageId) {
      case LanguageId.English:
        CultureInfo = 'en-GB';
        break;
      case LanguageId.Norwegian:
        CultureInfo = 'no-NO';
        break;
      case LanguageId.Swedish:
        CultureInfo = 'sv-SE';
        break;
      case 4:
        CultureInfo = 'pl-PL';
        break;
    }
    deviation.LanguageId = languageId;
    if (key === undefined) {
      return this.http
        .put(
          `${environment.BASE_URL}/${BaseServices.apiRoute(
            key
          )}deviation/${CultureInfo}`,
          deviation
        ).pipe(rxjsmap(result => result));
    } else {
      return this.http
        .put(
          `${environment.BASE_URL}/${BaseServices.apiRoute(
            key
          )}/deviation/${CultureInfo}`,
          deviation
        ).pipe(rxjsmap(result => result));
    }
  }
  // delete the topics
  deleteTopics(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/Delete/' + Id).pipe(rxjsmap((response: HttpHeaderResponse) => {
        return response;
      }));
  }
  // add the topics
  addTopics(data: any) {
    return this.http
      .post(environment.BASE_URL + '/Save', data).pipe(rxjsmap((response: HttpHeaderResponse) => {
        return response;
      }));
  }
  // update the topics
  updateTopics(data: any) {
    return this.http
      .put(environment.BASE_URL + '/Update', data).pipe(rxjsmap((response: HttpHeaderResponse) => {
        return response;
      }));
  }

  getDeviationLog(deviationId: number) {
    return this.http
      .get(environment.BASE_URL + '/project/deviation-log/' + deviationId).pipe(rxjsmap(result => result));
  }
  getUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContactLookup/' + id).pipe(rxjsmap((result: any) => result));
  }

  getById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviation/' + id).pipe(rxjsmap((result: any) => result));
  }
  getAllTopics(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/DeviationTopic/' + Id).pipe(rxjsmap(result => result));
  }
  getAllCaseType() {
    return this.http
      .get(
        environment.BASE_URL +
          '/casetypes/' +
          BaseServices.BusinessId +
          '/' +
          BaseServices.roleId
      ).pipe(rxjsmap((result: any) => result));
  }
  // delete deviation list
  deleteDev(Id: any) {
    return this.http
      .delete(environment.BASE_URL + '/deviation/' + Id).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
  }

  delete(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/Deviation/' + id).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
  }

  getCaseTypeById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/CaseType/' + id).pipe(rxjsmap(result => result));
  }

  // add Case type dropdown
  createCaseType(caseType: deviationCaseType) {
    return this.http
      .post(environment.BASE_URL + '/CaseType', JSON.stringify(caseType)).pipe(rxjsmap((response: HttpHeaderResponse) => {
        return response;
      }));
  }

  // edit case type dropdowm
  updateCaseType(caseType: deviationCaseType) {
    return this.http
      .put(environment.BASE_URL + '/CaseType/' + caseType.Id, caseType).pipe(rxjsmap((response: HttpHeaderResponse) => {
        return response;
      }));
  }

  // delete case type dropdown
  deleteType(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/CaseType/' + id).pipe(rxjsmap((response: HttpHeaderResponse) => {
        return response;
      }));
  }

  // add  the department
  addDepartment(data: any) {
    return this.http
      .post(environment.BASE_URL + '/department', data).pipe(rxjsmap(result => result));
  }

  // update  the department
  updateDepartment(department: Department) {
    return this.http
      .put(environment.BASE_URL + '/department/' + department.Id, department).pipe(rxjsmap(result => result));
  }

  //  delete  the department
  deleteDepartment(id: number) {
    return this.http.delete(environment.BASE_URL + '/departmentdelete/' + id);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  // check if type case is exist or not
  checkTypecaseExist(caseName: string) {
    return this.http
      .get(environment.BASE_URL + '/checkcasename/' + caseName).pipe(rxjsmap(result => result));
  }
  // check if topic is exist or not
  checkTopicExist(topicName: string) {
    return this.http
      .get(environment.BASE_URL + '/checktopicname/' + topicName).pipe(rxjsmap(result => result));
  }
  // check if deparment is exists or not
  checkDepartmentExist(departmentName: string) {
    return this.http
      .get(environment.BASE_URL + '/checkdepartmentname/' + departmentName).pipe(rxjsmap(result => result));
  }

  checkExistingTypeForDelete(caseId: number) {
    return this.http
      .get(environment.BASE_URL + '/checkcase/' + caseId).pipe(rxjsmap(result => result));
  }
  getDepartmentForAdmin(deviationId: number) {
    return this.http
      .get(environment.BASE_URL + '/getdepartmentbybusinessid/' + deviationId).pipe(rxjsmap((result: any) => result));
  }
  checkTopicForDeviation(topicId: number) {
    return this.http
      .get(environment.BASE_URL + '/checktopicfordeviation/' + topicId).pipe(rxjsmap(result => result));
  }

  reportGenerate(
    businessId: number,
    parentId: number,
    cultureInfo: string,
    ReportJson: any,
    Logging: string
  ) {
    let loginName = BaseServices.userProfile['Name'];
    let dynamicType = 'application/pdf';
    let myData = JSON.stringify({ data: ReportJson });
    let url = `${environment.BASE_URL}/export-DeviationBulkPrint/${businessId}/${parentId}/${cultureInfo}/${loginName}/${Logging}`;
    let crfToken = this.authenticationService.getCsrfToken();
    return Observable.create(observer => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Logo-Id', 'ab064fd4-9b4a-4e70-972d-dafdaceb2aba');
      xhr.setRequestHeader('X-XSRF-TOKEN', crfToken);
      xhr.responseType = 'blob';
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let contentType = dynamicType;
            let blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send(myData);
    });
  }

  deviationReportGenerate(
    projectId: number,
    businessId: number,
    deviationId: number,
    cultureInfo: string,
    deviation: any,
    FeatureId: number,
    userId: number
  ) {
    const url = `${environment.BASE_URL}/export-DeviationPrintDetails/${projectId}/${businessId}/${deviationId}/${cultureInfo}/${FeatureId}/${userId}`;

    return this.http.post(url, deviation, { responseType: 'blob' });
  }

  deleteDeviationAttachment(Id) {
    return this.http
      .delete(environment.BASE_URL + '/deletedeviationattachment/' + Id).pipe(rxjsmap(result => result));
  }
  getAssignedBusinessManual(businessId: number) {
    return this.http
      .get(`${environment.BASE_URL}/deviations/manualList/${businessId}`).pipe(rxjsmap((result: any) => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }
  getResponsibleAndAssignedUsersForFollowup(
    businessId: number,
    featureId: number,
    featureKey: number
  ) {
    return this.http
      .get(
        `${environment.BASE_URL}/assignedresponsibleusersfollowup/${businessId}/${featureId}/${featureKey}`
      ).pipe(rxjsmap(result => result));
  }
  getAssignedUsers(
    businessId: number,
    featureId: number,
    featurekey: number,
    applicationId: number
  ) {
    return this.http
      .get<any>(
        `${environment.BASE_URL}/AssignedPersons/${businessId}/${featurekey}/${featureId}/${applicationId}`
      ).pipe(rxjsmap(result => result));
  }
}
